<template>
  <div class="flex flex-col gap-8 px-10 pt-8 pb-10">
    <!-- Header: Title (close button is provided by modal wrapper) -->
    <h1 class="text-[34px] font-bold leading-none text-[#eaeaea] pr-12">
      {{ $t('publish_mission.step6.title') }}
    </h1>

    <!-- Content Section -->
    <div class="flex flex-col gap-8 w-full">
      <!-- Expert selection section -->
      <div class="flex flex-col gap-8">
        <div class="flex flex-col gap-6 w-full">
          <div class="flex flex-col gap-4 w-full">
            <!-- Subtitle -->
            <h2 class="text-[20px] font-bold leading-[1.1] text-[#eaeaea]">
              {{ $t('publish_mission.step6.experts_message') }}
            </h2>

            <!-- Avatar Stack -->
            <div
              v-if="selectedExperts.length > 0"
              class="flex items-center justify-center w-full"
            >
              <div class="flex items-center pr-[9px]">
                <div
                  v-for="(expert, index) in displayedExperts"
                  :key="expert.value"
                  class="size-14 rounded-full border-2 border-[#3b3b3b] overflow-hidden bg-gray-700 -mr-[9px] relative"
                  :style="{ zIndex: displayedExperts.length - index }"
                >
                  <img
                    v-if="expert.picture_url"
                    :src="expert.picture_url"
                    :alt="expert.label"
                    class="size-full object-cover"
                  />
                  <div v-else class="size-full flex items-center justify-center text-gray-400 text-sm font-medium">
                    {{ getInitials(expert.label) }}
                  </div>
                </div>
                <!-- Overflow count -->
                <div
                  v-if="selectedExperts.length > 3"
                  class="size-14 rounded-full border-2 border-[#3b3b3b] bg-gray-800 flex items-center justify-center text-gray-400 text-sm font-medium -mr-[9px]"
                  :style="{ zIndex: 0 }"
                >
                  +{{ selectedExperts.length - 3 }}
                </div>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div class="w-full h-px bg-[#373737]" />
        </div>

        <!-- Notification message -->
        <p class="text-[16px] font-normal leading-[1.4] text-[#eaeaea]">
          {{ $t('publish_mission.step6.notification_info') }}
        </p>
      </div>

      <!-- Finish button -->
      <div class="flex flex-col items-end w-full">
        <button
          type="button"
          class="w-full h-[45px] flex items-center justify-center gap-2.5 px-3 bg-[#f2f2f2] hover:bg-white rounded-lg transition-colors"
          @click="$emit('finish')"
        >
          <span class="text-[16px] font-semibold text-black">
            {{ $t('publish_mission.step6.finish') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface SelectedExpert {
  value: string;
  label: string;
  picture_url?: string;
}

interface Props {
  selectedExperts?: SelectedExpert[];
}

const props = withDefaults(defineProps<Props>(), {
  selectedExperts: () => [],
});

defineEmits<{
  finish: [];
}>();

const displayedExperts = computed(() => props.selectedExperts.slice(0, 3));

const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};
</script>
